import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { Button } from 'foundations-components/transitional/components/Button';
import { InvoiceIcon } from 'foundations-assets/icons/components/InvoiceIcon';
import { useIsPillBorderRadius } from 'portals-platform-lib';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { usePayInvoice } from '../../hooks/usePayInvoice';
import { buildInvoiceDetailsUrl } from '../../utils/invoiceUrls';
import { trackInteraction } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function OverdueInvoiceCard({
  invoice
}) {
  const {
    payInvoice,
    loading: isPayLoading
  } = usePayInvoice();
  const invoiceDetailsUrl = buildInvoiceDetailsUrl(invoice);
  const isPill = useIsPillBorderRadius();
  const tileProps = {
    'data-test-id': 'overdue-invoice-card',
    borderRadius: isPill ? '0' : '300'
  };
  return /*#__PURE__*/_jsx(Tile, Object.assign({}, tileProps, {
    children: /*#__PURE__*/_jsx(TileSection, {
      paddingBlock: "600",
      paddingInline: "600",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "300",
        children: [/*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          children: [/*#__PURE__*/_jsx(StatusDot, {
            use: "danger"
          }), /*#__PURE__*/_jsx(Text, {
            typography: "detail-200",
            color: "text-core-subtle",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "invoices.status.pastDue"
            })
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          children: [/*#__PURE__*/_jsx(InvoiceIcon, {
            size: "400"
          }), /*#__PURE__*/_jsx(Text, {
            typography: "heading-200",
            children: invoice.invoiceNumber
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          gap: "500",
          children: [/*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(Text, {
              typography: "body-125",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "invoices.totalAmount"
              })
            }), /*#__PURE__*/_jsx(Text, {
              typography: "body-100",
              children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
                value: Number(invoice.amountDue),
                currencyCode: invoice.currencyCode
              })
            })]
          }), /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(Text, {
              typography: "body-125",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "invoices.dueDateLabel"
              })
            }), typeof invoice.dueDate === 'number' && /*#__PURE__*/_jsx(Text, {
              typography: "body-100",
              children: /*#__PURE__*/_jsx(FormattedDateTime, {
                value: invoice.dueDate,
                format: "ll"
              })
            })]
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          gap: "300",
          children: [/*#__PURE__*/_jsx(Button, {
            use: "primary",
            "data-test-id": "pay-invoice-btn",
            disabled: isPayLoading || invoice.objectId === undefined,
            onClick: () => {
              trackInteraction('pay-invoice-clicked');
              payInvoice(invoice.objectId);
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "invoices.payNow"
            })
          }), /*#__PURE__*/_jsx(RouterButton, {
            use: "secondary-ghost",
            to: invoiceDetailsUrl,
            "data-test-id": "see-invoice-details-btn",
            disabled: !invoice.invoiceLink,
            onClick: () => trackInteraction('see-invoice-details'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "invoices.seeDetails"
            })
          })]
        })]
      })
    })
  }));
}